let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gLEw7")).then(() => parcelRequire('l4Hxk'));